import React from "react";
import "./Hero.css";

const Hero = () => {
  const handleEmailClick = () => {
    window.location.href = "mailto:KFoster98@proton.me";
  };

  const handleVenueClick = () => {
    const venueAddress = "Craft.19 Coffee shop on Main Street in Sumner";
    window.open(
      `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
        venueAddress
      )}`,
      "_blank"
    );
  };

  return (
    <section className="hero">
      {/* Background Image with Overlay */}
      <div className="hero-background">
        <div
          className="hero-image"
          style={{
            backgroundImage: `url('./business.jpeg')`,
          }}
        />
        <div className="hero-overlay" />
      </div>

      {/* Content Container */}
      <div className="hero-content">
        {/* Header with Logo and Contact Button */}
        <header className="hero-header">
          <div className="hero-logo">
            Businesses Grow<span> Together</span>
          </div>

          <button className="contact-top-button" onClick={handleEmailClick}>
            Contact Us
          </button>
        </header>

        {/* Main Content */}
        <div className="hero-main">
          <h1 className="hero-title">
            Build Your Network, <span className="highlight">Grow Together</span>
          </h1>

          <p className="hero-subtitle">
            Join our humble community of professionals who love to network and
            help build each other in business, mindset, and knowledge. We focus
            on making networking friendlier and more inviting.
          </p>

          {/* Buttons */}
          <div className="hero-buttons">
            <button className="hero-btn venue-btn" onClick={handleVenueClick}>
              <span className="btn-icon material-icons">location_on</span>
              Visit Our Venue
            </button>

            <button className="hero-btn contact-btn" onClick={handleEmailClick}>
              <span className="btn-icon material-icons">mail</span>
              Join Our Network
            </button>
          </div>

          {/* Meeting Info */}
          <div className="meeting-info">
            <div className="info-item">
              <span className="info-icon material-icons">access_time</span>
              <div className="info-content">
                <span className="info-label">When:</span>
                <span className="info-value">Every Wednesday at 8:00 AM</span>
              </div>
            </div>

            <div className="info-item">
              <span className="info-icon material-icons">place</span>
              <div className="info-content">
                <span className="info-label">Where:</span>
                <span className="info-value">
                  Craft.19 Coffee Shop, Main Street, Sumner
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;